export const shellPadding = 2 as const;
export const shellClass = 'genie-page-shell' as const;
